import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { PartnerOrganizationInfo } from '../fragments';

export default gql`
  mutation actionPartnerOrganizationMerge($input: PartnerOrganizationMergeActionInput!) {
    actionPartnerOrganizationMerge(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      previewData
      targetOrganization {
        ...PartnerOrganizationInfo
      }
    }
  }
  ${ErrorMessageInfo}
  ${PartnerOrganizationInfo}
`;
